import { authApi, merchantApi, pdpaApi } from "@api";
import { ComponentPopUpLoginAddress } from "@components";
import { PATH_SIGN_UP_FORM, PATH_SURVEY } from "@configs";
import { IAddressData, IAmphur, IField, IPdpa, IProvince, ISubDistrict } from "@interfaces";
import { selectApp, selectAuth, selectMerchant, setFromLogin, store } from "@redux";
import { newFormatMessage, splitMessage, useNotify } from "@utils";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";
import { ComponentPopUpNotic, ComponentUnfilledQuestions } from "./PopUpConfirm";
import { ComponentPopupStaticQuestion } from "./PopUpStaticQuestion";

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};

export const ComponentPdpa = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [pdpa, setPdpa] = useState<IPdpa[]>([]);
    const [question, setQuestions] = useState<IField[]>([]);
    const [loading, setLoading] = useState(true);
    const [isHasQuestion, setIsHasQuestion] = useState<boolean>(true);
    // const { userInfo } = useSelector(selectAuth);
    const { fromLogin, fromSignup } = useSelector(selectApp);
    const { userInfo } = useSelector(selectAuth);
    const history = useHistory();
    // const fromLogin = true;
    const { memberTypeGroupNameId, memberTypeNameId } = useSelector(selectApp);

    const merchant = useSelector(selectMerchant);
    const { themes } = useSelector(selectMerchant);
    const staticQuestion = merchant.signUpSettings?.staticQuestion;
    const [isStatic, setIsStatic] = useState<boolean>(false);
    const [staticList, setStaticList] = useState<any[]>([]);
    const [isAddress, setIsAddress] = useState<boolean>(false);

    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const token = store.getState().auth.auth?.accessToken;
    const [whileFetch, setWhiteFetch] = useState<boolean>(false);
    const [showCustom, setShowCustom] = useState<boolean>(true);

    const [openshowpopup, setOpenShowPopup] = useState<boolean>(false);

    const { success, error } = useNotify();
    useEffect(() => {
        if (token) {
            fetchNotice();
        }
    }, [token]);

    useEffect(() => {
        if (fromLogin && userInfo !== null) {
            checkPretype();
            fetchQuestion();
            fetchQuestionSignup();
            fetchAddressSignup();
            setOpenShowPopup(true);
            dispatch(setFromLogin(false));
        }
    }, [fromLogin, userInfo]);

    useEffect(() => {
        getAllProvince();
    }, []);

    const checkPretype = () => {
        if (merchant?.memberTypeConfig?.isPreform) {
            if (userInfo?.contact?.memberTypeGroupNameId === undefined && !fromSignup) {
                history.push(PATH_SIGN_UP_FORM);
            }
        }
    };

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0].province_id;
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };
    const onChangeSubDistrict = (value: any) => {
        let outSub = subDistrictList[value];
        setAddressData({
            ...addressData,
            subDistrict: value,
            postCode: outSub?.zipcode,
        });
    };
    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const confirmAddress = async () => {
        if (!staticQuestion?.address?.isRedeem) {
            if (staticQuestion?.address?.isRequired) {
                if (
                    addressData?.address === "" ||
                    addressData?.province === "" ||
                    addressData?.district === "" ||
                    addressData?.subDistrict === "" ||
                    addressData?.postCode === ""
                ) {
                    error(t("page.pls_answer_address"));
                    return;
                }
            }
        }

        let outSubDisIndex = 0;
        if (addressData?.subDistrict !== "") {
            outSubDisIndex = parseInt(addressData.subDistrict);
        }
        let proObj = provinceList.find((item) => item?.province_id === addressData?.province);
        let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
        let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
        let fullAdd = [
            addressData?.address,
            proObj?.province_name_tha,
            disObj?.amphur_name_tha,
            subObj?.district_name_tha,
            addressData.postCode,
        ].join(" ");
        let addressPayload: any = {
            address: {
                ...addressData,
                subDistrict:
                    addressData.subDistrict !== ""
                        ? subDistrictList[outSubDisIndex]?.district_id
                        : "",
            },
            fullAddress: fullAdd,
        };
        let ResAdd = await authApi.saveQuestionSignUp(addressPayload);
        setIsAddress(false);

        success(t("page.address_success"));
    };

    const fetchNotice = async () => {
        const res = await pdpaApi.getPdpasToAccept();
        if (res.data) {
            //@ts-ignore
            const notice = res.data.filter((item) => item.pdpaType === "notice");
            //@ts-ignore
            const consent = res.data.filter((item) => item.pdpaType !== "notice");
            setPdpa([...notice, ...consent]);
            setLoading(false);
        }
    };
    const fetchAddressSignup = async () => {
        let res = await merchantApi.getAddressIsRequire();
        if (res?.data?.result[0]?.address) {
            if (
                !res?.data?.result[0]?.address?.isRedeem &&
                res?.data?.result[0]?.address?.isRequired
            ) {
                setIsAddress(true);
            }
        }
    };

    const fetchQuestionSignup = async () => {
        const res = await authApi.getQuestionSignUp();
        if (res.data) {
            let outData = res.data.result;
            if (res.data.result.length !== 0) {
                let check = false;
                try {
                    await Promise.all(
                        res?.data?.result?.map(async (sItem: any) => {
                            if (sItem?.email !== "" && sItem?.email?.isActive) {
                                check = true;
                            }
                            if (sItem?.dateOfBirth !== "" && sItem?.dateOfBirth?.isActive) {
                                check = true;
                            }
                            if (sItem.gender !== "" && sItem?.gender?.isActive) {
                                check = true;
                            }
                            if (sItem?.memberPreType !== undefined) {
                                let arr: any[] = [];
                                sItem?.memberPreType?.static?.forEach((qItem: any) => {
                                    let obj: any = {};
                                    if (qItem.name === "email") {
                                        obj = {
                                            email: {
                                                isRequired: qItem?.isRequire,
                                                isActive: qItem?.isActive,
                                            },
                                        };
                                    } else if (qItem.name === "gender") {
                                        obj = {
                                            gender: {
                                                isRequired: true,
                                                isActive: true,
                                            },
                                        };
                                    } else if (qItem?.name === "dateOfBirth") {
                                        obj = {
                                            dateOfBirth: {
                                                isRequired: true,
                                                isActive: true,
                                            },
                                        };
                                    } else {
                                        obj = {
                                            isAnswer: true,
                                            isCustom: false,
                                            questionName: qItem?.name,
                                            isRequired: qItem?.isRequire || false,
                                        };
                                    }

                                    arr.push(obj);
                                });
                                outData = arr;
                                if (sItem?.memberPreType.static.length >= 0) {
                                    check = true;
                                }
                            }

                            if (sItem?.memberPreType?.question?.length > 0) {
                                let qId = userInfo?.contact?.memberTypeGroupNameId;
                                let tId = userInfo?.contact?.memberTypeNameId;
                                if (qId !== undefined && tId !== undefined) {
                                    let qPayload = {
                                        gId: qId,
                                        tId: tId,
                                    };
                                    const qRes = await authApi.getMemberTypeField(qPayload);
                                    const filteredItems = qRes.data?.filter((itemB: any) =>
                                        sItem?.memberPreType?.question.includes(
                                            itemB.contactCustomFieldId
                                        )
                                    );
                                    filteredItems?.forEach((fItem: any) => {
                                        let obj = {
                                            isAnswer: true,
                                            isCustom: true,
                                            questionName: fItem?.fieldName,
                                            isRequired: fItem?.isRequired,
                                            contactCustomFieldId: fItem?.contactCustomFieldId,
                                            isFreeTextAnswer: fItem?.isFreeTextAnswer,
                                            multiple: fItem?.multiple,
                                            options: fItem?.options,
                                            propertyName: fItem?.propertyName,
                                            _id: fItem?._id,
                                        };
                                        outData.push(obj);
                                    });
                                    setShowCustom(false);
                                }
                            }
                            setStaticList(outData);
                        })
                    );
                } catch (err) {
                    console.error("err", err);
                }

                if (check) {
                    setIsStatic(true);
                }
            }
        }
    };
    const fetchQuestion = async () => {
        const res = await authApi.getQuestionIsRequire();
        if (res.data) {
            setQuestions(res.data.result);
            // if (res.data.result.length === 0) {
            //     dispatch(setFromLogin(false));
            // }
        }
    };

    const handleConfirm = async (data: IPdpa, status: boolean) => {
        if (whileFetch === false) {
            try {
                setWhiteFetch(true);
                const hostname = window.location.hostname;
                const prefix = hostname.split(".")[0];
                if (prefix === "topcharoen") {
                    const headers = {
                        Authorization:
                            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJncm91cCI6IlJ1YW1jaGFyb2VuUGF0dGFuYSIsImlhdCI6MTY5NTI4NDY0N30.dxzt1iovJLTGqDVZdw6tIiKr-_4jz6PKLVxqltrHknI",
                    };
                    let topPayload = {
                        formName: data?.nameForm,
                        dataSubject_Name: userInfo?.contact?.fullName,
                        dataSubject_surName: "", //fix
                        email: userInfo?.contact?.email,
                        condition: data?.nameForm,
                        // purpose: data?.titleForm,
                        referrerName: "TopCharoen Member Program", //fix
                        identify_data: "ชื่อ-สกุล", //fix
                        ip: "", //maybe fix
                        time_Period: 0, //fix
                        userAgentID: "", //fix
                        "user-customize-01": userInfo?.contact?.phoneNumber,
                    };
                    let res = await axios.post("https://api.t-reg.co/Consent", topPayload, {
                        headers: headers,
                    });
                }
                const res = await pdpaApi.postPdpaToAccept({
                    pdpaId: data.pdpaId,
                    isAccept: status,
                });

                if (res.data.error === "0") {
                    setLoading(true);
                    const remove = pdpa.filter((item) => item.pdpaId !== data.pdpaId);
                    setPdpa(remove);
                    setLoading(false);
                    success(newFormatMessage(res));
                    if (pdpa.length <= 1) {
                        if (localStorage.getItem("QRCODE")) {
                            merchantApi
                                .qrClaimPoint({
                                    merchantId: userInfo?.merchantId || "",
                                    userId: userInfo?.contact?.userId || "",
                                    productOrderId: localStorage.getItem("QRCODE"),
                                })
                                .then((res) => {
                                    success(newFormatMessage(res));
                                    localStorage.removeItem("QRCODE");
                                    // history.push(PATH_HOME);
                                })
                                .catch((err) => {
                                    // error(err.message);
                                    error(newFormatMessage(err.response));
                                    localStorage.removeItem("QRCODE");
                                    // history.push(PATH_HOME);
                                });
                        }
                        if (
                            merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType &&
                            merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType ===
                                "default"
                        ) {
                            // history.push("/");
                            sessionStorage.setItem("FIRST_PAGE", "true");
                            sessionStorage.setItem("SING_UP", "true");
                        } else if (
                            merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType &&
                            merchant?.themes?.basicThemeSetting?.choiceFirstPage?.choiceType ===
                                "custom"
                        ) {
                            if (
                                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url &&
                                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url[0] === "/"
                            ) {
                                history.push(
                                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url
                                );
                            } else if (
                                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url &&
                                merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url[0] !== "/"
                            ) {
                                window.open(
                                    merchant?.themes?.basicThemeSetting?.choiceFirstPage?.url,
                                    "_self"
                                );
                            }
                            sessionStorage.setItem("FIRST_PAGE", "true");
                            sessionStorage.setItem("SING_UP", "true");
                        }
                    }
                } else {
                    setLoading(false);
                    error(newFormatMessage(res));
                }
            } catch (err: any) {
                const message = err.response?.data?.message
                    ? err.response?.data?.message
                    : err.message;
                if (message?.startsWith("002")) {
                    error(
                        splitMessage(
                            "Connection request error (522)||เกิดข้อผิดพลาดในการเชื่อมต่อ (522)"
                        )
                    );
                } else {
                    error(newFormatMessage(err.response));
                }
            } finally {
                setWhiteFetch(false);
            }
        }
    };
    return (
        <div>
            {loading ? null : (
                <>
                    {pdpa.length > 0 && (
                        <ComponentPopUpNotic data={pdpa[0]} handleConfirm={handleConfirm} />
                    )}
                    {pdpa.length === 0 && fromLogin && isStatic && staticList.length > 0 && (
                        <ComponentPopupStaticQuestion
                            isHasQuestion={isStatic}
                            handlDone={() => setIsStatic(false)}
                            data={staticList}
                        />
                    )}
                    {pdpa.length === 0 && fromLogin && !isStatic && isAddress && (
                        <ComponentPopUpLoginAddress
                            handleCloseDetail={() => setIsAddress(false)}
                            addressData={addressData}
                            provinceList={provinceList}
                            amphurList={amphurList}
                            subDistrictList={subDistrictList}
                            onChangeProvince={onChangeProvince}
                            onChangeAmphur={onChangeAmphur}
                            onChangeSubDistrict={onChangeSubDistrict}
                            setAddressText={setAddressText}
                            confirmAddress={confirmAddress}
                        />
                    )}
                    {/* comment for multi select */}
                    {showCustom &&
                        fromLogin &&
                        pdpa.length === 0 &&
                        question.length > 0 &&
                        isHasQuestion &&
                        !isStatic &&
                        !isAddress && (
                            <ComponentUnfilledQuestions
                                isHasQuestion={isHasQuestion}
                                handlDone={() => setIsHasQuestion(false)}
                                data={question}
                            />
                        )}

                    {pdpa.length === 0 &&
                        question.length === 0 &&
                        openshowpopup &&
                        merchant?.themes?.linkImageUrl && (
                            <StyledPopupRedeem>
                                <div className="box-popupconfirm">
                                    <img
                                        src={merchant?.themes?.linkImageUrl}
                                        alt=""
                                        onClick={() =>
                                            window.open(merchant?.themes?.linkUrl, "_self")
                                        }
                                    />
                                    <div
                                        className="box-close"
                                        onClick={() => {
                                            setOpenShowPopup(false);
                                            const survey = localStorage.getItem("SURVEY");
                                            if (localStorage.getItem("SURVEY")) {
                                                history.push(PATH_SURVEY + "/" + survey);
                                            }
                                        }}
                                    >
                                        {/* <img src="../images/ic-close-receipt.png" alt="" /> */}
                                        <IoIosCloseCircleOutline
                                            size={30}
                                            color={themes?.themeColor}
                                        />
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        )}
                </>
            )}
        </div>
    );
};

const StyledPopupRedeem = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        border-radius: 8px;
        width: calc(100% - 100px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        img {
            width: 100%;
        }
        .box-close {
            position: absolute;
            top: -14px;
            right: -14px;
            img {
                width: 30px;
                height: 30px;
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
`;
